// extracted by mini-css-extract-plugin
module.exports = {"Container":"Title_Container__3qKlt","Title":"Title_Title__2C6Lm"};